(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["av-bundle-inline"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-av-inline-bundle] .av-inline-bundle__button');
    if (!button) return;
    const bundle = button.closest('[data-av-inline-bundle]');
    const status = bundle.querySelector('.av-inline-bundle__status');
    button.disabled = true;
    status.textContent = '';
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [
          { id: Number(button.dataset.padId), quantity: 1 },
          { id: Number(button.dataset.serumId), quantity: 1 }
        ] })
      });
      if (!response.ok) throw new Error('bundle_add_failed');
      window.location.href = `${window.Shopify.routes.root}discount/PACKGLOW10?redirect=/cart`;
    } catch (error) {
      status.textContent = bundle.dataset.error;
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
